import React, {useState, useEffect, useContext} from 'react'
import PropTypes from 'prop-types'
import {List, Segment, Button, Header} from "semantic-ui-react";

const ProjectList = ({projects, onProjectSelect, onCreateProject}) => {

    return (
        <div>
            <Header as='h1' attached textAlign='center' inverted>Projecten</Header>
            <Segment>
                <Button size='tiny' onClick={onCreateProject}>Nieuw project</Button>
            </Segment>
            <Segment inverted>
                <List divided inverted relaxed>
                    {projects.map(project => {
                        return <List.Item key={project.id} style={{cursor: 'pointer'}} onClick={() => onProjectSelect(project)}>
                            <List.Content>
                                <List.Header>{project.naam}</List.Header>
                            </List.Content>
                        </List.Item>
                    })}


                </List>
            </Segment>
        </div>
    )
}

export default ProjectList

ProjectList.propTypes = {}

ProjectList.defaultProps = {}
